'use strict';

angular.module('far.ui.eventsCalendar', [])
.constant('eventsCalendarConfig', {
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    days: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс']
});